import React from "react";

export default function SpinnerOverlay({ message }) {
  return (
    <div className="spinner-overlay flex flex-col items-center justify-center gap-4">
      <div className="spinner"></div>
      {message && (
        <p className="text-white text-lg font-medium tracking-wide shadow-sm z-50 text-center px-4">
          {message}
        </p>
      )}
    </div>
  );
}